/**
 * Generate a unique ID for timers, rooms, etc.
 * Uses crypto.randomUUID if available, falls back to timestamp + random
 */
export function generateId(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
}

/**
 * Generate a short room code (6 uppercase alphanumeric characters)
 */
export function generateRoomCode(): string {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'; // Excluded I, O, 0, 1 for readability
  let code = '';
  for (let i = 0; i < 6; i++) {
    code += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return code;
}

/**
 * Auto-assign a color to a user based on their pseudo
 */
export function pseudoToColor(pseudo: string): string {
  const colors = [
    '#00e5ff', // cyan
    '#7c3aed', // violet
    '#10b981', // emerald
    '#f59e0b', // amber
    '#ef4444', // red
    '#ec4899', // pink
    '#8b5cf6', // purple
    '#06b6d4', // cyan-dark
    '#84cc16', // lime
    '#f97316', // orange
  ];
  let hash = 0;
  for (let i = 0; i < pseudo.length; i++) {
    hash = pseudo.charCodeAt(i) + ((hash << 5) - hash);
  }
  return colors[Math.abs(hash) % colors.length];
}
